// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_complete":"complete_mypage_subsc_complete__13HjC","mypage_subsc_back_button":"complete_mypage_subsc_back_button__27Wjk"};